import { Credential, MinisiteConfiguration } from '@3ddv/ngx-sites-builder-lib';
import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { PaginatedQueryModel } from 'src/app/shared/models/paginatedQuery.model';
import { SiteModel } from 'src/app/sites-builder/models/site.model';
import { SbApiService } from 'src/app/sites-builder/services/sb-api.service';
import { CredentialModel } from './model/credential.model';
import { CredentialsService } from './services/credentials.service';

@Component({
  selector: 'app-credentials',
  templateUrl: './credentials.component.html',
  styleUrls: ['./credentials.component.scss'],
})
export class CredentialsComponent implements OnInit {
  // From initial state: sb-manager/sb-list.component.ts
  public site: SiteModel;
  public closeReason: 'success' | 'cancel';

  private subscriptions: Array<Subscription>;

  public minisiteConfiguration: MinisiteConfiguration;
  public credentialsToolEnabled: boolean;
  // public credentialsTool: Credential;
  public credentialsList: CredentialModel[];

  public isAddingCredentials: boolean;
  public newCredentials: { username: string; password: string };

  public isEditingCredentials: boolean;
  public editionCredentials: CredentialModel | null;
  public editionOldUsername: string;

  public isDeletingCredentials: boolean;
  public deletionCredentials: CredentialModel | null;
  public deletionUsername: string;

  // public areCredentialsChanges: boolean;

  constructor(
    private bsModalRef: BsModalRef,
    private sbApiService: SbApiService,
    private credentialsService: CredentialsService,
    private toastrService: ToastrService
  ) {}

  // ngOnDestroy(): void {
  //   this.subscriptions.forEach((o) => o.unsubscribe());
  // }

  ngOnInit(): void {
    this.isAddingCredentials = false;
    this.newCredentials = { username: '', password: '' };

    this.isEditingCredentials = false;
    this.editionCredentials = null;
    this.editionOldUsername = '';

    this.isDeletingCredentials = false;
    this.deletionCredentials = null;
    this.deletionUsername = '';

    // this.areCredentialsChanges = false;
    console.log('Site', this.site);

    // Get master file --> credential tool enabled?
    this.getMasterFile(this.site.path_master);
    // Get all users credentials --> list
    this.credentialsList = this.site.credentials;
  }
  private getMasterFile(masterPath: string) {
    this.sbApiService.getMasterFile(masterPath).subscribe({
      next: response => {
        // this.minisiteConfiguration = response;
        this.minisiteConfiguration = Object.assign({}, response);
        // console.log('Master File', this.minisiteConfiguration);
        console.log('Credential Tool', this.minisiteConfiguration.toolsConfig.credential);
        this.credentialsToolEnabled = this.minisiteConfiguration.toolsConfig.credential.enabled;
        // this.credentialsTool = this.minisiteConfiguration.toolsConfig.credential;
      },
      error: error => console.error(error),
    });
  }

  public onDisable() {
    this.newCredentials.username = null;
    this.newCredentials.password = null;
  }
  // CREDENTIALS CRUD

  public createCredentials() {
    if (!this.credentialsToolEnabled) {
      this.onCancel('create');
      return;
    }
    const usernameExists: boolean = this.credentialsList.some(
      credentials => credentials.username === this.newCredentials.username
    );
    console.log('Username Exists: ', usernameExists);

    if (usernameExists) {
      this.toastrService.warning('Estas credenciales ya existen.', 'Un momento!');
    } else {
      const credentials = this.createNewCredentials();
      console.log(credentials);
      this.credentialsService.postCredentials(credentials).subscribe({
        next: response => {
          console.log(response);
          // Get all users credentials --> list
          //this.getCredentialsList();

          // Closing creation dialog
          this.isAddingCredentials = false;
          this.newCredentials = { username: '', password: '' };
          this.editionOldUsername = '';

          // Toastr state message
          this.toastrService.success('Las credenciales han sido creadas con éxito.', 'Bien!');
        },
        error: error => {
          console.error(error);
          // Toastr state message
          this.toastrService.error('Algo ha ido mal.', 'Ups!');
        },
      });
    }
  }

  public editCredentials(credentials: CredentialModel) {
    // console.log('credentials edit: ', credentials);
    this.credentialsService.editCredentials(credentials).subscribe({
      next: response => {
        console.log('Credentials EDITED: ', response.credential);
        // Get all users credentials --> list
        //this.getCredentialsList();

        // Closing edition dialog
        this.isEditingCredentials = false;
        this.editionCredentials = null;
        this.editionOldUsername = '';

        // Toastr state message
        this.toastrService.success('Las credenciales han sido editadas con éxito.', 'Bien!');
      },
      error: error => {
        console.error(error);
        // Toastr state message
        this.toastrService.error('Algo ha ido mal.', 'Ups!');
      },
    });
  }

  public deleteCredentials(credentials: CredentialModel) {
    this.credentialsService.deleteCredentials(credentials.id).subscribe({
      next: response => {
        console.log('Credentials DELETED: ', response);
        // Get all users credentials --> list
        //this.getCredentialsList();
        this.credentialsList = [];
        console.log(credentials);
        this.credentialsList.filter(c => {
          if (c.id !== credentials.id) {
            this.credentialsList.push(c);
          }
        });
        // Closing deletion dialog
        this.isDeletingCredentials = false;
        this.deletionCredentials = null;
        this.deletionUsername = '';

        // Toastr state message
        this.toastrService.success('Las credenciales han sido borradas con éxito.', 'Bien!');
      },
      error: error => {
        console.error(error);
        // Toastr state message
        this.toastrService.error('Algo ha ido mal.', 'Ups!');
      },
    });
  }

  private createNewCredentials(): CredentialModel {
    return {
      username: this.newCredentials.username,
      password: this.newCredentials.password,
      site_id: this.site.id,
      is_admin: 0,
    };
  }

  // USER input buttons actions

  public editUserCeredentials(credentials: CredentialModel) {
    console.log(credentials);
    this.isEditingCredentials = true;
    this.editionCredentials = credentials;
    this.editionOldUsername = credentials.username;
  }

  public deleteUserCeredentials(credentials: CredentialModel) {
    console.log(credentials);
    this.isDeletingCredentials = true;
    this.deletionCredentials = credentials;
    this.deletionUsername = credentials.username;
  }

  public onCancel(mode: string): void {
    if (mode === 'new') {
      this.isAddingCredentials = false;
      this.newCredentials = {
        username: '',
        password: '',
      };
    } else if (mode === 'edit') {
      this.isEditingCredentials = false;
      this.editionCredentials = null;
      this.editionOldUsername = '';
    } else if (mode === 'delete') {
      this.isDeletingCredentials = false;
      this.deletionCredentials = null;
      this.deletionUsername = '';
    }
  }

  public onSubmit(mode: string): void {
    console.log('Mode: ', mode);
    if (mode === 'new') {
      if (this.newCredentials.username !== '' && this.newCredentials.password !== '') {
        this.createCredentials();
      }
    } else if (mode === 'edit') {
      if (this.editionCredentials.username !== '' || this.editionCredentials.password !== '') {
        this.editCredentials(this.editionCredentials);
      }
    } else if (mode === 'delete') {
      this.deleteCredentials(this.deletionCredentials);
    }
  }

  public generatePassword() {
    this.newCredentials.password = '';
    const characters = '0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const passwordLength = 10;
    for (let i = 0; i <= passwordLength; i++) {
      const randomNumber = Math.floor(Math.random() * characters.length);
      this.newCredentials.password += characters.substring(randomNumber, randomNumber + 1);
    }
  }

  // MODAL buttons actions

  public onDismiss(reason: 'cancel') {
    this.closeReason = reason;
    this.bsModalRef.hide();
  }

  public onConfirm() {
    // Update credentials tool
    this.minisiteConfiguration.toolsConfig.credential.enabled = this.credentialsToolEnabled;
    this.minisiteConfiguration = Object.assign({}, this.minisiteConfiguration);
    // console.log('Master File Modified: ', this.minisiteConfiguration);
    console.log('Credential Tool Modified: ', this.minisiteConfiguration.toolsConfig.credential);

    const formData: FormData = new FormData();
    // Transform json to string
    const body = JSON.stringify(this.minisiteConfiguration);
    const blob = new Blob([body], { type: 'application/json' });
    // Transform string to file
    const file = new File([blob], 'master.json');
    console.log('File: ', file);
    // Create form
    formData.append('master_file', file);
    // Send form as body

    // BD required data
    formData.append('client_key', this.site.client_key);
    // formData.append('venue_key', this.site.venue_key);
    formData.append('venue_code', this.site.venue_code);
    // formData.append('template_color_id', this.site.template_color_id);
    // formData.append('template_map_id', this.site.template_map_id);
    formData.append('workflow_id', this.site.workflow_id.toString());
    formData.append('title', this.site.title);
    formData.append('url', this.site.url);
    formData.append('map_id', this.site.map_id);
    formData.append('is_active', this.site.is_active.toString());

    // let post$ =
    this.sbApiService.updateSite(this.site.id, formData).subscribe({
      next: res => {
        // console.log(res);
        if (res.site) {
          console.log('Site Updated: ', res.site);
          this.closeReason = 'success';
          this.bsModalRef.hide();
        }

        // Get master file --> credential tool enabled?
        // this.getMasterFile(this.site.path_master);
      },
      error: error => {
        console.error(error);
        // Toastr state message
        this.toastrService.error('Algo ha ido mal.', 'Ups!');
      },
    });

    // this.subscriptions.push(post$);
  }
}
